import React from "react";
import RiseLoader from "react-spinners/RiseLoader";
import "./loader.css";
const Loader = () => {
  return (
    <React.Fragment>
      {/* <div className="loader-col">
        <RiseLoader color="#35e6e9" />
      </div> */}
      <div
        className={`flex items-center justify-center w-full h-full min-h-[350px] bg-white`}
      >
        <RiseLoader color="#35e6e9" />
      </div>
    </React.Fragment>
  );
};

export default Loader;
